var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { gql, useQuery } from '@apollo/client';
import { FilterProductEnum, callSideEffects } from '../../util';
import { currentHotelFilterSelectionsVar, defaultAvailableHotelFilters } from './currentHotelFilters';
import { mapToFilterCriteria } from '../../util/filters/mapToFilterCriteria';
// Why do I have to pass a arg to CurrentHotelSearchParams?
const HOTEL_FILTERS_QUERY = gql `
    query CurrentAvailableHotelFilters($tripStateId: ID!) {
        currentAvailableHotelFilters @client {
            ... on CheckboxFilterGroup {
                id
                name
                open
                type
                items {
                    id
                    selected
                    label
                    count
                }
                pill
            }
            ... on RangeFilterGroup {
                id
                name
                open
                type
                max
                min
                upper
                lower
                formatString
                step
            }
            ... on TextFilter {
                id
                name
                open
                type
                value
            }
        }
    }
`;
export function useFilterHotels(sideEffects) {
    const setHotelFilters = (filters) => __awaiter(this, void 0, void 0, function* () {
        currentHotelFilterSelectionsVar(mapToFilterCriteria(filters));
        callSideEffects(sideEffects, { product: FilterProductEnum.HOTEL, filterGroups: filters });
    });
    const { data: queryData } = useQuery(HOTEL_FILTERS_QUERY, {
        notifyOnNetworkStatusChange: true,
        ssr: false,
    });
    const availableHotelFilters = (queryData === null || queryData === void 0 ? void 0 : queryData.currentAvailableHotelFilters) || defaultAvailableHotelFilters;
    return [availableHotelFilters, setHotelFilters];
}
